import { useShallow } from 'zustand/react/shallow'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
import type { MessageUserLevelUp } from '../../../types/lives/messages'

const LIVE_USERS_LEVELS = '/LIVE-USERS-LEVELS'

export const useUpdateUserLevelUp = () => {
  const liveId = useGlobalStore(
    useShallow((state) => {
      return state.liveId
    }),
  )

  const addNotifyUserLevelUpList = useGlobalStore(
    useShallow((state) => {
      return state.addNotifyUserLevelUpList
    }),
  )

  // global
  useSub<MessageUserLevelUp>({
    endpoint: `${LIVE_USERS_LEVELS}`,
    skip: !liveId,
    onData: (data) => {
      addNotifyUserLevelUpList({
        ...data,
        id: `${Date.now()}`,
      })
    },
  })

  // local
  useSub<MessageUserLevelUp>({
    endpoint: `${LIVE_USERS_LEVELS}/${liveId}`,
    skip: !liveId,
    onData: (data) => {
      addNotifyUserLevelUpList({
        ...data,
        id: `${Date.now()}`,
      })
    },
  })
}
